import React from "react";
import CountUp from "react-countup";
import BannerBg from "../../../assets/images/shapes/shape-02.png";
import AboutUs from "../../../assets/images/resource/about-us.png";
import shape1 from "../../../assets/images/shapes/shape-01.png";
import partner from "../../../assets/images/cloudera-partner-badge.jpg";
import JourneyTimeline from "../../JourneyTimeline";
import "../../JourneyTimeline.css";

const AboutTwo = () => {
  return (
    <section className="about__section p_relative p-5">
      <div className="pattern-layer">
        {/* <div
          className="pattern-2 p_absolute"
          data-parallax='{"x": -50}'
          style={{ backgroundImage: `url(${BannerBg})` }}
        ></div> */}
      </div>
      {/* <div className="boild__text">
        <h1>Smart iLab Works</h1>
      </div> */}
      <div className="auto-container">
        <div className="row">
          {/* <div className="col-lg-6 col-md-12">
            <div className="about__block p_relative">
              <figure
                className="wow zoomIn animated"
                data-wow-delay="100ms"
                data-wow-duration="1500ms"
              >
                <img src={AboutUs} alt="" />
              </figure>
              <div
                className="funfact__content about"
                style={{ backgroundImage: `url(${shape1})` }}
              >
                <div className="count-outer count-box">
                  <h1 className="count-text">
                    <CountUp start={0} end={10} />
                    <span>K+</span>
                  </h1>
                </div>
                <p>World wide Client</p>
              </div>
            </div>
          </div> */}
          <div className="col-lg-1"></div>
          <div className="col-lg-12 col-md-12">
            <div className="about__text__block">
              <div className="sub__title">
                <h4 style={{ color: "#009999" }}>About Us</h4>
              </div>
              <div className="title two about">
                <h2
                  style={{
                    color: "#009999",
                    fontSize: "30px",
                  }}
                >
                  Welcome to Smart iLab Works - Empowering Your Business with AI
                  and RPA Solutions
                </h2>
              </div>

              <div className="texts">
                <p style={{ textAlign: "justify" }}>
                  At Smart iLab Works, we're pioneering the future of
                  data-driven decision-making through cutting-edge artificial
                  intelligence solutions. Our mission is to empower businesses
                  of all sizes to harness the power of data to drive innovation,
                  efficiency, and growth.
                </p>

                <section
                  className="title two"
                  style={{
                    backgroundcolor: "#009999",
                    textalign: "center",
                  }}
                >
                  <h2
                    style={{
                      color: "#000",
                      fontWeight: 500,
                      fontSize:"30px",
                    }}
                  >
                    Who We Are
                  </h2>
                  <p style={{ textAlign: "justify" }}>
                    We are a team of passionate data scientists, AI engineers,
                    and business strategists dedicated to delivering tailor-made
                    AI and RPA solutions that address our clients' unique
                    challenges. With a deep understanding of both technology and
                    business domains, we're committed to unlocking the full
                    potential of data to transform industries.
                  </p>
                </section>
                <h2
                  style={{ color: "#000", fontWeight: 500,
                      fontSize:"30px", }}
                >
                  What we do
                </h2>

                <ul className="what-we-do-ul">
                  <li className="what-we-do">
                    <strong>AI and RPA Consulting:</strong> We provide expert
                    guidance and consulting services to help businesses
                    integrate AI & RPA into their operations effectively.
                  </li>
                  <li className="what-we-do">
                    <strong>Data Analytics:</strong> Set up big data
                    clusters on-premises and in the cloud, and design, build,
                    deploy, and maintain end-to-end data pipelines for
                    enterprise data lakes.
                  </li>
                  <li className="what-we-do">
                    <strong>Web Development:</strong> We
                    deliver robust, secure, and scalable web solutions aligned
                    with organizational objectives.
                  </li>
                  <li className="what-we-do">
                    <strong>Digital Consulting:</strong> Our digital consulting
                    services provide strategic guidance on technology adoption,
                    system optimization, and user-centric design to enhance
                    operational efficiency and support sustainable business
                    growth.
                  </li>
                  <li className="what-we-do">
                    <strong>AI Training and Workshops:</strong> We offer
                    training programs and workshops to equip businesses and
                    professionals with the skills needed to leverage AI
                    technologies effectively.
                  </li>
                </ul>
                <div>
                  <section
                    className="title two"
                    style={{
                      backgroundcolor: "#009999",
                      textalign: "center",
                    }}
                  >
                    <h2
                      style={{
                        color: "#000",
                        fontWeight: 500,
                      fontSize:"30px",
                      }}
                    >
                      Our Impact
                    </h2>
                    <p style={{ textAlign: "justify" }}>
                      Our solutions have helped numerous organizations across
                      various industries unlock new opportunities, optimize
                      processes, and achieve measurable results. Whether it's
                      improving customer experience, streamlining operations, or
                      enhancing product performance, we're committed to driving
                      tangible outcomes for our clients.
                    </p>
                  </section>

                  <section
                    className="title two"
                    style={{
                      backgroundcolor: "#009999",
                      textalign: "center",
                    }}
                  >
                    <h2
                      style={{
                        color: "#000",
                        fontWeight: 500,
                      fontSize:"30px",
                      }}
                    >
                      Collaborate with Us
                    </h2>
                    <p style={{ textAlign: "justify" }}>
                      Are you ready to embark on a trans-formative AI and RPA
                      journey? Whether you're a startup looking to innovate or
                      an established enterprise seeking to stay ahead of the
                      curve, we're here to support you every step of the way.
                      Let's collaborate to unlock the full potential of AI and
                      RPA for your business.{" "}
                    </p>
                  </section>
                  <section
                    className="title two"
                    style={{
                      backgroundcolor: "#009999",
                      textalign: "center",
                    }}
                  >
                    <h2
                      style={{
                        color: "#000",
                        fontWeight: 500,
                      fontSize:"30px",
                      }}
                    >
                      Our Trusted Partnerships
                    </h2>
                    <p style={{ textAlign: "justify" }}>
                      At SIW, we collaborate with leading technology partners to
                      deliver cutting-edge data solutions. As a proud{" "}
                      <strong>Cloudera Partner Network Member</strong>, we
                      leverage the Cloudera Data Platform to provide secure,
                      scalable, and enterprise-grade data engineering and
                      analytics solutions.
                    </p>
                    <a
                      href="https://www.cloudera.com/partners.html"
                      target="_blank"
                      rel="noopener"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <img
                        src={partner}
                        alt="Cloudera Partner Network Member"
                        style={{
                          maxHeight: "100px",
                          marginTop: "30px",
                        }}
                      />
                    </a>
                  </section>
                  <br />
                </div>
                <div>
                  <JourneyTimeline />
                </div>
                {/* <p>2019 – Set up City National Bank Oracle BDA cluster and design, built, deploy and maintain end-to-end data pipelines on Enterprise Data Lake.​
                  <br></br>
                   2020 – Successfully conducted online 'Coding for Kids' classes during the COVID period, expanding into education and community impact.
                   <br></br>
                   2021 – Deployed a secure Kafka Confluent Platform 7.1 cluster using Ansible automation and delivered data engineering solutions.​
                   <br></br>
                   2022 – Partnered with Cloudera to upgrade the platform from CDH 5.14.4 to CDP 7.1.7, ensuring smooth access to data for data science and engineering teams.​
                   <br></br>
                   2023 – Implemented Kafka and Spark Streaming pipelines integrating S3, Spark, Kafka, and Solace source/sink connectors.​
                   <br></br>
                   2024 – Built the Alvigor web application with Open APIs (Python, Flask, MySQL) using tools like Notion, Promod, and World Time.​
                   <br></br>
                   2024 – Delivered multi-vendor solutions: WhatsApp Store, API integration, and e-commerce; set up social media presence.​
                   <br></br>
                   2024 – Implemented Taftc Accounts RPAs: ERP login via RPA, Ready to Payout RPA, Email Sharing RPA, and Disbursement to Marvel.​
                   <br></br>
                   2025 – Digital Consultant – Produced 100+ social media videos to build brand awareness and education.​
                  <br></br>
                   2025 – RPA Consultant – Deployed Accounts RPA in Tembusu Institute (Course Validation, Disburse Validation, Credit Note Validation).​
                  <br></br>
                   2025 – RPA Consultant – Implemented HR RPA in Tembusu Institute (Trainers’ Fee Calculation, Attendance Report, TRAQOM Survey Report).​
                  <br></br>
                   2025 – AI/Data Consultant – Set up AWS-based Cloudera clusters and labs: Admin, Data Engineering, Data Analyst, CAI, and CML labs.​
                  <br></br>
                   2025 – AI/Data Consultant – Created an e-learning platform for the Above.​</p>   */}
                {/* <p>
                  Based in Singapore, we deliver high-quality, cost-effective,
                  and reliable solutions tailored to evolving business needs.
                </p>
                <p>
                  From business analysis to deployment and maintenance, we
                  provide seamless, end-to-end services, ensuring smooth
                  execution so you can focus on what matters most.
                </p> */}

                {/* <div className="title two">
                    <h2 style={{ color: "#009999", padding: "20px 0px" }}>
                      Our expertise includes:
                    </h2>
                  </div> */}
                {/* <ul className="bullet-list">
                    <li>
                      <p>
                        <strong>We specialize in AI & data engineering</strong>{" "}
                        to optimize big data Platform deployments and data
                        science to uncover valuable insights from complex
                        datasets.
                      </p>
                    </li>
                    <li>AI and RPA to automate processes</li>
                    <li>
                      Seamless integration of React applications with OpenAPI
                      and Single Sign-On
                    </li>
                    <li>
                      e-Commerce website and multi-vendor application
                      development
                    </li>
                    <li>
                      WhatsApp E-Store services to enhance customer engagement
                    </li>
                    <li>
                      Custom Web and Mobile App Development to create powerful
                      digital solutions
                    </li>
                    <li>
                      <strong>Our digital consulting services</strong> empower
                      businesses with data-driven strategies, market insights,
                      and tailored solutions, strengthening digital presence and
                      ensuring long-term success.
                    </li>
                    <li>
                      <strong>Through digital consulting</strong>, we drive
                      strategic transformation, optimizing brand positioning,
                      customer engagement, and operational efficiency.
                    </li>
                  </ul> */}
                <p>{/* <br /> */}</p>
                <p>{/* <br /> */}</p>
                <h4
                  className="about-two-h4"
                  style={{ padding: "20px 0px 50px" }}
                >
                  {/* <br /> */}
                  <strong style={{ color: "#009999" }}>At SiW</strong>, we don’t
                  just offer solutions—we become your trusted technology
                  partner, delivering innovation with precision. Let’s shape the
                  future together.
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutTwo;
